module.exports = __webpack_public_path__ + "img/orange-tiny-terror.d0e5918f.jpg";